<!--
 * @Description: 用户条目组件(污水费)
--> 

<template>
  <div class="user-item-sewage">
    <div class="item-title">
      <div class="title-wrapper">
        <div class="title-lalel" style="font-size:14px;font-weight:400;">
          用户号：
        </div>
        <div class="title-value">{{item.yhh}}</div>
      </div>
      <!-- <div class="title-btn">
        <van-button plain type="info" size="small" color="rgba(37,138,55,1)">立即绑定</van-button>
      </div> -->
    </div>
    <div class="item-info">
      <div class="info-lalel">户名：</div>
      <div class="info-value">{{item.yhmc}}</div>
    </div>
    <div class="item-info">
      <div class="info-lalel">用水地址：</div>
      <div class="info-value">{{item.ysdz}}</div>
    </div>
    <van-divider />
    <van-row style="font-size:14px;">
      <van-col span="12">
        到期欠费：{{item.dqqf}} 元
      </van-col>
      <van-col span="12">
        违约金：{{item.wyj}} 元
      </van-col>
    </van-row>
    <div class="item-title item-fee">
      <div class="title-wrapper">
        <div class="title-lalel" style="font-size:14px;">欠费金额：</div>
        <div class="title-value">
          <span class="fee-color">{{item.hjje}}</span>&nbsp;元
        </div>
      </div>
      <div class="title-btn">
        <van-button @click="rightNowPay(item)" size="small" type="info" class="search-btn">
          立即缴纳
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserItem',
  components: {
  },
  props: {
    item: Object
  },
  data() {
    return {
    }
  },
  methods: {
    rightNowPay(item){
      location.href = item.wechaturl
    }
  },
}
</script>

<style lang="less" scoped>
.user-item-sewage{
  background:rgba(255,255,255,1);
  border-radius:4px;
  padding: 16px 13px;
  .item-title{
    display: flex;
    justify-content: space-between;
    .title-wrapper{
      width: calc(~"100% - 90px");
      display: flex;
      justify-content: space-between;
      .title-label{
        width: 80px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(33,33,33,1);
      }
      .title-value{
        width: calc(~"100% - 80px");
        font-size:14px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(33,33,33,1);
        .fee-color{
          font-size:20px;
          font-weight:Semibold;
          color:#FF0000
        }
      }
    }
    .title-btn{
      width: 85px;
      text-align: right;
      height:30px;
      border-radius:3px;
    }
  }
  .item-info{
    display: flex;
    justify-content: space-between;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(33,33,33,1);
    .info-label{
      width: 80px;
    }
    .info-value{
      width: calc(~"100% - 80px");
    }
  }
  .item-fee{
    // margin-top: 21px;
    // border-top: 1px solid #cccccc;
    height: 62.5px;
    line-height:62.5px;
  }
  .barcode{
    height: 130px;
    background:rgba(37,138,55,1);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 3px 30px;
    .code-img{
      width: 100px;
      height: 100px;
      img{
        width: 100px;
        height: 100px;
      }
    }
    .code-info{
      width: calc(~"100% - 100px");
      margin-left: 30px;
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(255,255,255,1);
    }
  }
  .toptip {
    position: relative;
  }
  .toptip:after {
    border: 5px solid transparent;
    border-bottom: 10px solid rgba(37,138,55,1);
    position: absolute;
    content: "";
    left: 97%;
    margin-left: -10px;
    bottom: 100%;
  }
}
</style>